import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICartItemIssue) {
    (function(Reason) {
        /**
     * If an option was added as individual unit but later it was changed to a prepack
     * actions: REMOVE
     */ Reason["PRE_PACK_MISSING_COLLECTION_ID"] = "PRE_PACK_MISSING_COLLECTION_ID";
        /**
     * If a prepack was added and later deactivated
     * actions: REMOVE
     */ Reason["PRE_PACK_DEACTIVATED"] = "PRE_PACK_DEACTIVATED";
        /**
     * If a prepack composition (eg 1-2-2-1) was changed, and either the ratios have changed
     * or one or more items have been added/removed from the prepack configuration.
     * actions: REMOVE, CHANGE_QUANTITY, AUTO_FIX
     */ Reason["PRE_PACK_COMPOSITION_CHANGED"] = "PRE_PACK_COMPOSITION_CHANGED";
        /**
     * If the item cannot be purchased by online retailers and you are one
     * actions: REMOVE
     */ Reason["ONLINE_RESTRICTED_ITEM"] = "ONLINE_RESTRICTED_ITEM";
        /**
     * If the cart item says there was a tester but there is no longer one
     * actions: ACK, REMOVE
     */ Reason["STALE_TESTER_PRESENT"] = "STALE_TESTER_PRESENT";
        /**
     * If the tester price has changed
     * actions: ACK, REMOVE
     */ Reason["TESTER_WITH_STALE_PRICE"] = "TESTER_WITH_STALE_PRICE";
        /**
     * If the product is deactivated := brand inactive or product not for sale or option not for sale
     * actions: REMOVE
     */ Reason["PRODUCT_DEACTIVATED"] = "PRODUCT_DEACTIVATED";
        /**
     * If the MOQ has changed and product is now invalid
     * actions: REMOVE, CHANGE_QUANTITY, AUTO_FIX
     */ Reason["INVALID_MOQ"] = "INVALID_MOQ";
        /**
     * If the price has changed since it was last updated on the cart
     * actions: ACK, REMOVE
     */ Reason["STALE_PRICE"] = "STALE_PRICE";
        /**
     * If the unit multiplier (aka case size) was changed and is now invalid
     * actions: REMOVE, CHANGE_QUANTITY, AUTO_FIX
     */ Reason["INVALID_UNIT_MULTIPLIER"] = "INVALID_UNIT_MULTIPLIER";
        /**
     * If the product currently requires a customization that is not present on the cart
     * actions: REMOVE
     */ Reason["MISSING_CUSTOMIZATION"] = "MISSING_CUSTOMIZATION";
        /**
     * If the item cannot be purchased for retailers on a particular platform and you are one
     * actions: REMOVE
     */ Reason["RETAILER_PLATFORM_RESTRICTED_ITEM"] = "RETAILER_PLATFORM_RESTRICTED_ITEM";
        /**
     * If the item is out of stock, retailer cannot buy it and must be removed
     * action: REMOVE
     */ Reason["PRODUCT_OUT_OF_STOCK"] = "PRODUCT_OUT_OF_STOCK";
        /**
     * If the item does not have enough availability, retailer cannot buy full amount
     * actions: REMOVE, CHANGE_QUANTITY, AUTO_FIX
     */ Reason["INSUFFICIENT_STOCK"] = "INSUFFICIENT_STOCK";
        /**
     * If the brand has elected not to sell in the retailer's region
     */ Reason["REGION_RESTRICTED_ITEM"] = "REGION_RESTRICTED_ITEM";
        /**
     * If MOQ has changed andn product is now invalid for an Open Sizing item
     * cannot change quantity since no way to know which option should increase
     * actions: REMOVE, AUTO_FIX
     */ Reason["INVALID_MOQ_OPEN_SIZING"] = "INVALID_MOQ_OPEN_SIZING";
        /**
     * Alcohol is restricted in the retailer's region
     * action: Remove
     */ Reason["ALCOHOL_RESTRICTED_REGION"] = "ALCOHOL_RESTRICTED_REGION";
        /**
     * Category is restricted in the retailer's region
     * action: REMOVE
     */ Reason["CATEGORY_RESTRICTED_REGION"] = "CATEGORY_RESTRICTED_REGION";
        /**
     * If the brand disallows unverified retailers from placing preorders
     * action: REMOVE
     */ Reason["PREORDER_RESTRICTED_UNVERIFIED_RETAILER"] = "PREORDER_RESTRICTED_UNVERIFIED_RETAILER";
        /**
     * The retailer has not hit the qualification requirement for a free display product
     * action: REMOVE
     */ Reason["DISPLAY_PRODUCT_UNDER_MINIMUM"] = "DISPLAY_PRODUCT_UNDER_MINIMUM";
        /**
     * The retailer has not hit the qualification requirement for a free display product
     * action: REMOVE
     */ Reason["DISPLAY_PRODUCT_NOT_AVAILABLE"] = "DISPLAY_PRODUCT_NOT_AVAILABLE";
    })(ICartItemIssue.Reason || (ICartItemIssue.Reason = {}));
    (function(Action) {
        /**
     * Remove the item from the cart will fix the issue. This is always an option.
     */ Action["REMOVE"] = "REMOVE";
        /**
     * No change is required, just acknowledge some stale information will change.
     */ Action["ACK"] = "ACK";
        /**
     * The current quantity in the cart is invalid and requires changing.
     */ Action["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
        /**
     * This is the improved ACK. It is used for errors when the BE can make some
     * assumption to fix but, unlike ACK, it does make changes (writes).
     * Clients should only show this as a last resort before REMOVE; if you can fix
     * using a more specific action, do so.
     * For example, the INVALID_MOQ reason, apart from REMOVE, supports both CHANGE_QUANTITY
     * and AUTO_FIX. If clients can support the CHANGE_QUANTITY and let the user pick a correct
     * quantity, that is better UX. If not, they can use the AUTO_FIX option to have it
     * automatically increased to the valid minimum.
     * In general this works as a possible fallback for new actions we might add in the future
     * that won't be supported for all clients.
     */ Action["AUTO_FIX"] = "AUTO_FIX";
    })(ICartItemIssue.Action || (ICartItemIssue.Action = {}));
    (function(IUpdatedCartItemInformation) {
        IUpdatedCartItemInformation.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(ICartItemIssue.IUpdatedCartItemInformation || (ICartItemIssue.IUpdatedCartItemInformation = {}));
    ICartItemIssue.build = function(partial) {
        return _object_spread({
            actions: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICartItemIssue || (ICartItemIssue = {}));
export var ICartItemIssue;
